module.exports = __webpack_public_path__ + "static/aymi-d227eb7256aacfd49aced5259983577b.svg";